module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAABVUlEQVR4Ae3cv03EQBBGcZfgEi4lIqCBLcEJuUugBHdACdMAPbiU7YAtYfgkfEI6BCsC3+ygd9KTLnLwk+zbf+cp8vPw+DSrTVXlwe1qVbOarh1fQlpUUz5YVZVooKJ88JZIoJoAqKk5AmdVnqQtAmhPBFQjgDxT/xsIIIAAen57HymAAALohAACCCCAAAIIIF3gol6OLmr6a6mBOjir8ptMzQB9AjXlPyAB1LmwKYA6GUD9DKB+BlA/A6ifAdTP8gN9DQKr8hOy1EDHtMFPzjIDNeV3yLIC+R1bAPq9ClAngADiFuMhzc88A0WmGkxWxwZiuYMFM5ZcWbRn24eNQ7aeObzwyumO78dfyhHHX04IIIAAAggggAACCCCAAOJPvRmBAAIIoJoIaI8A2hIBrRFAs2oJcGrkG6iWBEAlDOioDPo8ampR0xUoulXtg9xS2+1rAj8AKO/siLFFEpEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4f2.png
// module id = 1065
// module chunks = 0